import React, { useEffect, useState } from 'react'

import { CalendarOutlined } from '@ant-design/icons'
import { Card, Col, Icon, Row, Typography } from 'antd'

import AtentionIcon from '../../../assets/images/atentionIcon.svg'
import Clockicon from '../../../assets/images/clockIcon.svg'
import QuestionIcon from '../../../assets/images/questionIcon.svg'
import SucessIcon from '../../../assets/images/sucessIcon.svg'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import { renderChart, stackedBarChart } from '../../Dashboard/chart-props'

import './Visits.css'

const Visits = function ({ customer }) {
  const [collapsed, setCollapsed] = useState(false)
  const [actionResultData, setActionResultData] = useState({
    actionsCount: 0,
    finished: {
      quant: 0,
      percent: 0
    },
    unplanned: {
      quant: 0,
      percent: 0
    },
    planed: {
      quant: 0,
      percent: 0
    },
    late: {
      quant: 0,
      percent: 0
    }
  })

  useEffect(() => {
    if (customer.id) {
      getChartFilteredData(customer)
    }
  }, [])

  async function getChartFilteredData(params) {
    request(api.getReportActionsChart(params.id))
      .then((result) => {
        setActionResultData(result)
      })
      .catch((error) => {
        console.tron.log('getChartFilteredData - error', error)
      })
  }

  const toggleCollapsed = () => setCollapsed((val) => !val)

  return (
    <div>
      <div style={{ padding: '2%' }}>
        <div className="default-header-div">
          <div className="default-header-breadcrumb">
            <Typography.Title className="default-header-title" level={3}>
              <Icon
                type={collapsed ? 'up' : 'down'}
                style={{ marginRight: 13, fontSize: 15 }}
                onClick={toggleCollapsed}
              />
              <CalendarOutlined style={{ marginRight: 13 }} />
              {getMessage('viewActions')}
            </Typography.Title>
          </div>

          {collapsed ? (
            actionsResults(actionResultData.actionsCount) === null &&
            actionsProportionResults(actionResultData) === null ? (
              <div className="container-empty-actions">
                <CalendarOutlined className="icon-actions" />
                <Typography className="default-header-title label-empty-actions" level={3}>
                  {getMessage('actionsEmpty')}
                </Typography>
              </div>
            ) : (
              <div style={{ display: 'flex' }}>
                <Card className="ant-card gx-card ant-card-bordered" style={{ width: '100%', marginRight: 14 }}>
                  <div style={{ justifyContent: 'flex-start' }}>{actionsResults(actionResultData.actionsCount)}</div>
                </Card>

                <Card className="ant-card gx-card ant-card-bordered" style={{ width: '300%' }}>
                  <div style={{ justifyContent: 'flex-start' }}>{actionsProportionResults(actionResultData)}</div>
                </Card>
              </div>
            )
          ) : null}
        </div>
      </div>
    </div>
  )

  function actionsResults(actionsTotal) {
    let actions = null

    if (actionsTotal !== 0) {
      actions = (
        <div className="container-count-actions">
          <Typography className="label-total-actions">{getMessage('totalActions')}</Typography>
          <div className="horizontal-line" style={{ marginTop: '14%', width: '100%' }} />
          <Typography className="result-total-actions">{actionsTotal}</Typography>
        </div>
      )
    }

    return actions
  }

  function actionsProportionResults(actionsData) {
    const finishedPercent = parseFloat(actionsData.finished.percent).toLocaleString('pt-BR')
    const unplannedPercent = parseFloat(actionsData.unplanned.percent).toLocaleString('pt-BR')
    const planedPercent = parseFloat(actionsData.planed.percent).toLocaleString('pt-BR')
    const latePercent = parseFloat(actionsData.late.percent).toLocaleString('pt-BR')
    const actionsValues = [
      {
        data: [finishedPercent]
      },
      {
        data: [unplannedPercent]
      },
      {
        data: [planedPercent]
      },
      {
        data: [latePercent]
      }
    ]

    const renderstackedChart = stackedBarChart(actionsValues)

    let percetCahrt = null

    if (
      actionsValues[0].data !== 0 ||
      actionsValues[1].data !== 0 ||
      actionsValues[2].data !== 0 ||
      actionsValues[3].data !== 0
    ) {
      const finishedQtd = parseFloat(actionsData.finished.quant).toLocaleString('pt-BR')
      const unplannedQtd = parseFloat(actionsData.unplanned.quant).toLocaleString('pt-BR')
      const planedQtd = parseFloat(actionsData.planed.quant).toLocaleString('pt-BR')
      percetCahrt = (
        <>
          <Row type="flex" justify="start" style={{ justifyContent: 'space-around' }}>
            <Col span={5}>
              <div style={{ display: 'flex' }}>
                <img src={SucessIcon} alt="SucessIcon" width={27} style={{ marginRight: 5 }} />
                <Typography className="label-performed-actions">{'Realizadas: '}</Typography>
                <Typography className="value-actions">{finishedQtd}</Typography>
                <Typography className="representative-data-actions">{`(${finishedPercent}%)`}</Typography>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ display: 'flex' }}>
                <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
                <img src={QuestionIcon} alt="QuestionIcon" width={27} style={{ marginRight: 5 }} />
                <Typography className="label-unplanned-actions">{'Não Planejadas: '}</Typography>
                <Typography className="value-actions">{unplannedQtd}</Typography>
                <Typography className="representative-data-actions">{`(${unplannedPercent}%)`}</Typography>
              </div>
            </Col>
            <Col span={5}>
              <div style={{ display: 'flex' }}>
                <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
                <img src={Clockicon} alt="Clockicon" width={27} style={{ marginRight: 5 }} />
                <Typography className="label-planned-actions">{'Planejadas: '}</Typography>
                <Typography className="value-actions">{planedQtd}</Typography>
                <Typography className="representative-data-actions">{`(${planedPercent}%)`}</Typography>
              </div>
            </Col>
            <Col span={5}>
              <div style={{ display: 'flex' }}>
                <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
                <img src={AtentionIcon} alt="AtentionIcon" width={27} style={{ marginRight: 5 }} />
                <Typography className="label-late-actions">{'Atrasadas: '}</Typography>
                <Typography className="value-actions">{actionsData.late.quant}</Typography>
                <Typography className="representative-data-actions">{`(${latePercent}%)`}</Typography>
              </div>
            </Col>
          </Row>
          <div className="horizontal-line" style={{ marginTop: '3%', width: '100%' }} />
          <div style={{ marginLeft: -30, marginTop: -15, marginBottom: -30, textAlign: '-webkit-center' }}>
            {renderChart({ chart: renderstackedChart })}
          </div>
        </>
      )
    }

    return percetCahrt
  }
}

export default Visits
